/**
*  料金シミュレーター
*
*  通所リハビリテーション
*
*  @since 2019.9.24
*  @use jQuery
*/




/**
*  Variables
*
*  自己負担となる利用金額
*/

const array_daycare = {
  /* 介護度に応じたサービス料 */
  kaigo:
  [
    // 介護度 1 : [ 1割, 2割, 3割 ]
    {
      normal: [ 1704, 2568, 3431 ],
      short : [ , ,  ]
    },
    // 介護度 2 : [ 1割, 2割, 3割 ]
    {
      normal: [ 1852, 2863, 3874 ],
      short : [ , , ]
    },
    // 介護度 3 : [ 1割, 2割, 3割 ]
    {
      normal: [ 1998, 3156, 4314 ],
      short : [ , ,  ]
    },
    // 介護度 4 : [ 1割, 2割, 3割 ]
    {
      normal: [ 2168, 3495, 4822 ],
      short : [ ,, ]
    },
    // 介護度 5 : [ 1割, 2割, 3割 ]
    {
      normal: [ 2338, 3836, 5333 ],
      short : [ , , ]
    },
    // 要支援 1 : [ 1割, 2割, 3割 ]
    {
      normal: [ 840, 840, 840 ],
      short : [ , , ]
    },
    // 要支援 2 : [ 1割, 2割, 3割 ]
    {
      normal: [ 840, 840, 840 ],
      short : [ , , ]
    }
  ],
  addition:
  [
    // 介護度 1 : [ 1割, 2割, 3割 ]0
    [ 656, 1312, 1969 ],
    // 介護度 2 : [ 1割, 2割, 3割 ]
    [ 656, 1312, 1969 ],
    // 介護度 3 : [ 1割, 2割, 3割 ]
    [ 656, 1312, 1969 ],
    // 介護度 4 : [ 1割, 2割, 3割 ]
    [ 656, 1312, 1969 ],
    // 介護度 5 : [ 1割, 2割, 3割 ]
    [ 656, 1312, 1969 ],
    // 要支援 1 : [ 1割, 2割, 3割 ]
    [ 2734, 5468, 8202 ],
    // 要支援 2 : [ 1割, 2割, 3割 ]
    [ 5045, 10090, 15135 ],
  ],
  week:
  [
    {value:4 , name: '週1回'},
    {value:8 , name: '週2回'},
    {value:12, name: '週3回'},
  ]
}

/**
*  function
*  動作
*/

// 通所リハビリテーション
$( calcBtn.rehaDaycare ).on('click', function(e){
  e.preventDefault();

  const formData = $( currentForm.rehaDaycare ).serializeArray();
  const selectVal = selectCheck( currentForm.rehaDaycare, formData );
  let daysExpense, monthExpense;

  // すべて選択されていれば flag = true
  if( selectVal ){

    /* 計算処理開始 */
    // 1日の利用時間に応じて居住費を設定
    // switch( parseInt( selectVal.days, 10 ) )
    // {
    //   // 通常（6時間以上～8時間未満）
    //   case 1:
    //     daysExpense = array_daycare.kaigo[ selectVal.kaigo ].normal[ selectVal.futan ];
    //   break;
    //   // 短時間（1時間以上2時間未満）
    //   case 2:
    //     daysExpense = array_daycare.kaigo[ selectVal.kaigo ].short[ selectVal.futan ];
    //   break;
    //   // default
    //   default:
    //     return;
    //   break;
    // }

    daysExpense = array_daycare.kaigo[ selectVal.kaigo ].normal[ selectVal.futan ];
    monthExpense = array_daycare.addition[ selectVal.kaigo ][ selectVal.futan ];

    // 結果を出して表示する
    //const result = parseInt( daysExpense, 10) * parseInt( selectVal.weeks, 10);
    const result = (parseInt( daysExpense, 10) * parseInt( selectVal.weeks, 10)) + parseInt(monthExpense, 10);

    $( resultElm.rehaDaycare ).html( numberWithComma.format( result ) );

  } // end of 計算処理開始
return;
});


$( currentForm.rehaDaycare + ' [name="kaigo"]' ).on('change', function(){

  const kaigoValue = this.value;
  const weekOption = this.form.weeks;
  weekOption.innerHTML = '<option value="">選択してください</option>';

  const createOption = (value, name) => {
    const option = document.createElement('option');
    option.value = value;
    option.textContent = name;
    weekOption.appendChild(option);
  };

  if ( kaigoValue == 5) {
    weekOption.innerHTML = '';
    createOption(array_daycare.week[0].value,array_daycare.week[0].name);
  } else if (kaigoValue == 6) {
    weekOption.innerHTML = '';
    createOption(array_daycare.week[1].value,array_daycare.week[1].name);
  } else if (kaigoValue) {
    array_daycare.week.forEach((v) => {
      createOption(v.value,v.name,);
    });
  }

});